import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardHeader, CardTitle, CardContent, CardFooter, CardDescription } from "@/components/ui/card";
import { useToast } from "@/components/ui/use-toast";
import { fetchAPI } from "@/lib/api";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = await fetchAPI("?type=login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      if (data.status === "success" && data.token) {
        localStorage.setItem("admin_token", data.token);
        localStorage.setItem("username", data.user.username);
        // Only store if true to keep it clean, or store string "true"/"false"
        if (data.user.is_superuser) {
            localStorage.setItem("is_superuser", "true");
        } else {
            localStorage.removeItem("is_superuser");
        }
        if (data.user.profile_image) {
            localStorage.setItem("admin_profile_image", data.user.profile_image);
        } else {
             localStorage.removeItem("admin_profile_image");
        }
        
        if (data.user.permissions) {
             localStorage.setItem("admin_permissions", JSON.stringify(data.user.permissions));
        } else {
             localStorage.setItem("admin_permissions", "[]");
        }
        
        localStorage.setItem("admin_login_timestamp", Date.now().toString());
        
        toast({ title: "Welcome back", description: "Logged in successfully" });
        navigate("/admin-panel/dashboard");
      } else {
        throw new Error(data.message || "Login failed");
      }
    } catch (err: any) {
      toast({ 
        variant: "destructive", 
        title: "Login Failed", 
        description: err.message 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl text-center">Admin Login</CardTitle>
          <CardDescription className="text-center">Enter your credentials to access the dashboard</CardDescription>
        </CardHeader>
        <form onSubmit={handleLogin}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="username">Username</Label>
              <Input 
                id="username" 
                type="text" 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
                required 
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input 
                id="password" 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
              />
            </div>
          </CardContent>
          <CardFooter>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
